import './PetProfile.scss';

import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { loadAppointmentsRequests } from 'actions/appointments';
import FullScreenLoader from 'atoms/full-screen-loader';
import ListItem from 'organisms/Appointments/List/ListItem';
import NewAppointmentButton from 'organisms/NewAppointmentButton';
import { isEmpty } from 'util';

import { PetInformation } from './PetInformation';

function PetProfile() {
  const dispatch = useDispatch();
  const params = useParams();
  const [petInformation, setPetInformation] = useState();
  const { petAppointments } = useSelector((state) => state.petInformation);
  const { active, past } = petAppointments;
  const pastAppointments = past;
  const bookedAppointments = active.filter((appt) => appt.status.id === 1);
  const requestedAppointments = active.filter((appt) => appt.status.id === 2);
  const newAppointmentData = {
    client: {
      avatarUrls: petInformation?.animal?.avatarUrls,
      breed: petInformation?.animal?.breed,
      name: petInformation?.animal?.name,
      size: petInformation?.animal?.size,
      type: petInformation?.animal?.type,
      uuid: petInformation?.animal?.uuid,
      owner: {
        firstName: petInformation?.user?.firstName,
        lastName: petInformation?.user?.lastName,
        payment: petInformation?.user?.payment,
        phone: petInformation?.user?.phone,
        email: petInformation?.user?.email,
        uuid: petInformation?.user?.uuid,
      },
    },
  };

  useEffect(() => {
    dispatch(loadAppointmentsRequests(params.petId)).then(
      ({ success, data }) => {
        if (success) {
          const { animal, user } = data.data;
          setPetInformation({ animal, user });
        }
      }
    );
  }, []);

  useEffect(() => {
    if (petAppointments && petAppointments.animal && petAppointments.user) {
      const { animal, user } = petAppointments;
      setPetInformation({ animal, user });
    }
  }, [petAppointments]);

  if (!petInformation) return <FullScreenLoader />;

  const hasAppointments = !!active.length || !!past.length;

  return (
    <div className="flex-row w-100 pet-profile">
      <Helmet title="Pet profile | PawCare" />
      <PetInformation pet={petInformation} />
      <div className="page-container pb-50-mobile">
        {hasAppointments && (
          <div className="new-appointment-button-container flex-row justify-end mt-45">
            {hasAppointments && (
              <NewAppointmentButton data={newAppointmentData} />
            )}
          </div>
        )}
        {hasAppointments ? (
          <>
            {requestedAppointments.length > 0 && (
              <div className="mb-75 mt-n40">
                <h2 className="mb-15">New request</h2>

                {requestedAppointments.map((item) => (
                  <ListItem
                    showInnerDate
                    showOutterDate={false}
                    showUserNumber={false}
                    showPetDetails={false}
                    showAvatar={false}
                    limitWidth
                    key={item.uuid}
                    item={{
                      ...item,
                      animal: petInformation?.animal,
                      user: petInformation?.user,
                    }}
                    isNewRequest
                  />
                ))}
              </div>
            )}
            {bookedAppointments.length > 0 && (
              <div className="mb-75 mt-n40">
                <h2 className="mb-15">Scheduled</h2>
                {bookedAppointments.map((item) => (
                  <ListItem
                    showInnerDate
                    showOutterDate={false}
                    showUserNumber={false}
                    showPetDetails={false}
                    showAvatar={false}
                    limitWidth
                    key={item.uuid}
                    item={{
                      ...item,
                      animal: petInformation?.animal,
                      user: petInformation?.user,
                    }}
                  />
                ))}
              </div>
            )}
            {pastAppointments.length > 0 && (
              <div className="mb-75 mt-n40">
                <h2 className="mb-15">Past</h2>

                {pastAppointments.map((item) => (
                  <ListItem
                    showInnerDate
                    showOutterDate={false}
                    showUserNumber={false}
                    showPetDetails={false}
                    showAvatar={false}
                    limitWidth
                    key={item.uuid}
                    item={{
                      ...item,
                      animal: petInformation?.animal,
                      user: petInformation?.user,
                    }}
                  />
                ))}
              </div>
            )}
          </>
        ) : (
          !isEmpty(petInformation) && (
            <div className="book-first-appointment mt-45 flex-column w-100 align-center justify-center">
              <h3 className="mb-15">
                Book {petInformation?.animal?.name}&apos;s first appointment
              </h3>
              <NewAppointmentButton
                data={newAppointmentData}
                variant="default"
              />
            </div>
          )
        )}
      </div>
    </div>
  );
}

export default PetProfile;
